import React, { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const faqItems = [
    {
      question: "Do I need any programming experience to use Nozomi Robotics?",
      answer: "No prior programming experience is needed. Nozomi Robotics was designed to be accessible for beginners with its visual block-based programming interface. We provide step-by-step tutorials to get you started."
    },
    {
      question: "How long does it take to assemble the robot?",
      answer: "Most users can assemble the robot in about 30-45 minutes following our video guide. Assembly requires no soldering or special tools - everything you need is included in the kit."
    },
    {
      question: "Can the robot be expanded with additional sensors or components?",
      answer: "Yes! The Nozomi Robotics platform is designed to be expandable."
    },
    {
      question: "Is Nozomi Robotics suitable for classroom use?",
      answer: "Absolutely. Nozomi Robotics was developed with educational settings in mind. We offer a curriculum integration guide for teachers who want to incorporate Nozomi Robotics into their computing or STEM curriculum."
    },
    {
      question: "What age range is Nozomi Robotics appropriate for?",
      answer: "Nozomi Robotics is designed for ages 8 and up. Younger children can use it with adult supervision, while older students and adults can explore more advanced programming concepts and challenges."
    }
  ];

  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleQuestion = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <section id="faq" className="section faq-section">
      <div className="container">
        <div className="section-title">
          <h2>Frequently Asked Questions</h2>
          <p>Common questions about Nozomi Robotics</p>
        </div>

        <div className="faq-container">
          {faqItems.map((item, index) => (
            <div
              className={`faq-item ${expandedIndex === index ? 'expanded' : ''}`}
              key={index}
            >
              <button
                className="faq-question"
                onClick={() => toggleQuestion(index)}
                aria-expanded={expandedIndex === index}
              >
                {item.question}
                <span className="faq-icon">{expandedIndex === index ? '−' : '+'}</span>
              </button>
              <div className="faq-answer">
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;